import {NOT_FOUND_IMAGE_PATH, STEPS} from '../settings.js'

export const getInitialProps = async ({routeInfo, context: {domain, i18n}}) => {
  const {
    location: {state}
  } = routeInfo

  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  const {
    VEHICLE_SUGGESTER_PATH_PATTERN: homeSuggesterPath,
    VEHICLE_SUGGESTER_SEATS_PAGE_NAME: pageName,
    VEHICLE_SUGGESTER_MAKES_PATH_PATTERN: nextPagePath,
    VEHICLE_SUGGESTER_FUEL_TYPE_PATH_PATTERN: previousPagePath
  } = config.get('page')

  const {InvalidParamsSharedError} = config.get('COMMON').ERRORS

  const [error, seatsOptionsResponse] = await domain.get('get_configurator_seats_options_vehicles_use_case').execute({
    priceFrom: state?.priceRange?.from,
    priceTo: state?.priceRange?.to,
    bodyTypeIds: state?.bodyTypeIds,
    fuelTypeIds: state?.fuelTypeIds
  })
  if (error instanceof InvalidParamsSharedError) {
    console.error('Price range, body type ids and fuel type ids are required to fetch seats options')
    return {__HTTP__: {redirectTo: homeSuggesterPath}}
  }
  if (error) {
    return {
      isError: true,
      image: `${URL_STATICS_IMAGES}${NOT_FOUND_IMAGE_PATH}`,
      title: i18n.t('VEHICLE_CONFIGURATOR.MESSAGES.NOT_FOUND_ERROR_TITLE'),
      description: i18n.t('VEHICLE_CONFIGURATOR.MESSAGES.NOT_FOUND_ERROR_DESCRIPTION')
    }
  }

  const seatsOptions = seatsOptionsResponse.getFilterOptions()

  return {
    description: i18n.t('VEHICLE_SUGGESTER.STEP_SEATS.DESCRIPTION'),
    h1: i18n.t('COMMON.SUGGESTER'),
    nextPagePath,
    seatsOptions,
    pageName,
    previousPagePath,
    step: STEPS.SEATS,
    stepBreadcrumb: i18n.t('COMMON.SEATS'),
    title: i18n.t('VEHICLE_SUGGESTER.STEP_SEATS.TITLE')
  }
}
